import * as types from '../mutation-types';
import { Module } from 'vuex';

interface State {
  eventStartingSoon: WSEventStartingSoon | null;
  pageGenerated: WSPageGenerated | null;
  episodeConverted: WSEpisodeConverted | null;
  eventUpdated: WSEventUpdated | null;
  connected: boolean;
  error: {} | null;
}

const initialState: State = {
  eventStartingSoon: null,
  pageGenerated: null,
  episodeConverted: null,
  eventUpdated: null,
  connected: false,
  error: null,
};

const websocketModule: Module<State, any> = {
  namespaced: true,
  state: initialState,
  getters: {
    eventStartingSoon: state => state.eventStartingSoon,
    eventUpdated: state => state.eventUpdated,
    pageGenerated: state => state.pageGenerated,
    episodeConverted: state => state.episodeConverted,
  },
  actions: {
    eventReceived({ commit }, event) {
      const eventPayload = event.payload;
      commit(event.event_type.toUpperCase(), eventPayload);
    },
  },
  mutations: {
    [types.EVENT_UPDATED](state: State, event) {
      state.eventStartingSoon = event;
    },
    [types.PAGE_GENERATED](state: State, page) {
      state.pageGenerated = page;
    },
    [types.PODCAST_EPISODE_CONVERTED](state: State, episode) {
      state.episodeConverted = episode;
    },
    [types.EVENT_STARTING_SOON](state: State, event) {
      state.eventUpdated = event;
    },
    [types.SOCKET_ONOPEN](state: State) {
      state.connected = true;
    },
    [types.SOCKET_ONCLOSE](state: State) {
      state.connected = false;
    },
    [types.SOCKET_ONERROR](state: State, error) {
      state.error = error;
    },
  },
};

export default websocketModule;
